// Image metadata configuration
// This file contains all image metadata in a structured format
// A staff engineer would centralize this data for better maintainability

export const imageMetadata = {
	residential: [
		{
			id: "before_after1",
			filename: "before_after1.png",
			alt: "Before (left) and After (right)",
			category: "residential",
			description: "Before (left) and After (right)",
			tags: [
				"residential",
				"before-after",
				"comparison",
				"transformation",
				"windows",
				"installation",
			],
		},
		{
			id: "image_1",
			filename: "image_1.png",
			alt: "Residential glass installation project",
			category: "residential",
			description: "",
			tags: ["residential", "windows", "installation"],
		},
		{
			id: "image_10",
			filename: "image_10.png",
			alt: "Residential glass installation project",
			category: "residential",
			description: "",
			tags: ["residential", "windows", "installation"],
		},
		{
			id: "image_11",
			filename: "image_11.png",
			alt: "Residential glass installation project",
			category: "commercial",
			description: "",
			tags: ["commercial", "windows", "installation"],
		},
		{
			id: "image_12",
			filename: "image_12.png",
			alt: "Residential glass installation project",
			category: "commercial",
			description: "",
			tags: ["commercial", "windows", "installation"],
		},
		{
			id: "image_13",
			filename: "image_13.png",
			alt: "Residential glass installation project",
			category: "commercial",
			description: "",
			tags: ["residential", "windows", "installation"],
		},
		{
			id: "image_14",
			filename: "image_14.png",
			alt: "Residential glass installation project",
			category: "residential",
			description: "",
			tags: ["residential", "windows", "installation"],
		},
		{
			id: "image_15",
			filename: "image_15.png",
			alt: "Residential glass installation project",
			category: "residential",
			description: "",
			tags: ["residential", "windows", "installation"],
		},
		{
			id: "image_16",
			filename: "image_16.png",
			alt: "Residential glass installation project",
			category: "residential",
			description: "",
			tags: ["residential", "windows", "installation"],
		},
		{
			id: "image_17",
			filename: "image_17.png",
			alt: "Residential glass installation project",
			category: "commercial",
			description: "",
			tags: ["commercial", "windows", "installation"],
		},
		{
			id: "image_18",
			filename: "image_18.png",
			alt: "Residential glass installation project",
			category: "commercial",
			description: "",
			tags: ["commercial", "windows", "installation"],
		},
		{
			id: "image_19",
			filename: "image_19.png",
			alt: "Residential glass installation project",
			category: "residential",
			description: "",
			tags: ["residential", "windows", "installation"],
		},
		{
			id: "image_2",
			filename: "image_2.png",
			alt: "Residential glass installation project",
			category: "residential",
			description: "",
			tags: ["residential", "windows", "installation"],
		},
		{
			id: "image_20",
			filename: "image_20.png",
			alt: "Residential glass installation project",
			category: "residential",
			description: "",
			tags: ["residential", "windows", "installation"],
		},
		{
			id: "image_21",
			filename: "image_21.png",
			alt: "Residential glass installation project",
			category: "residential",
			description: "",
			tags: ["residential", "windows", "installation"],
		},
		{
			id: "image_22",
			filename: "image_22.png",
			alt: "Residential glass installation project",
			category: "residential",
			description: "",
			tags: ["residential", "windows", "installation"],
		},
		{
			id: "image_23",
			filename: "image_23.png",
			alt: "Residential glass installation project",
			category: "residential",
			description: "",
			tags: ["residential", "windows", "installation"],
		},
		{
			id: "image_24",
			filename: "image_24.png",
			alt: "Residential glass installation project",
			category: "residential",
			description: "",
			tags: ["residential", "windows", "installation"],
		},
		{
			id: "image_25",
			filename: "image_25.png",
			alt: "Residential glass installation project",
			category: "residential",
			description: "",
			tags: ["residential", "windows", "installation"],
		},
		{
			id: "image_26",
			filename: "image_26.png",
			alt: "Residential glass installation project",
			category: "residential",
			description: "",
			tags: ["residential", "windows", "installation"],
		},
		{
			id: "image_27",
			filename: "image_27.png",
			alt: "Residential glass installation project",
			category: "commercial",
			description: "",
			tags: ["commercial", "windows", "installation"],
		},
		{
			id: "image_28",
			filename: "image_28.png",
			alt: "Residential glass installation project",
			category: "residential",
			description: "",
			tags: ["residential", "windows", "installation"],
		},
		{
			id: "image_29",
			filename: "image_29.png",
			alt: "Residential glass installation project",
			category: "residential",
			description: "",
			tags: ["residential", "windows", "installation"],
		},
		{
			id: "image_3",
			filename: "image_3.png",
			alt: "Residential glass installation project",
			category: "residential",
			description: "",
			tags: ["residential", "windows", "installation"],
		},
		{
			id: "image_30",
			filename: "image_30.png",
			alt: "Residential glass installation project",
			category: "residential",
			description: "",
			tags: ["residential", "windows", "installation"],
		},
		{
			id: "image_31",
			filename: "image_31.png",
			alt: "Residential glass installation project",
			category: "residential",
			description: "",
			tags: ["residential", "windows", "installation"],
		},
		{
			id: "image_32",
			filename: "image_32.png",
			alt: "Residential glass installation project",
			category: "residential",
			description: "",
			tags: ["residential", "windows", "installation"],
		},
		{
			id: "image_35",
			filename: "image_35.png",
			alt: "Residential glass installation project",
			category: "residential",
			description: "",
			tags: ["residential", "windows", "installation"],
		},
		{
			id: "image_36",
			filename: "image_36.png",
			alt: "Residential glass installation project",
			category: "residential",
			description: "",
			tags: ["residential", "windows", "installation"],
		},
		{
			id: "image_37",
			filename: "image_37.png",
			alt: "Residential glass installation project",
			category: "residential",
			description: "",
			tags: ["residential", "windows", "installation"],
		},
		{
			id: "image_38",
			filename: "image_38.png",
			alt: "Residential glass installation project",
			category: "residential",
			description: "",
			tags: ["residential", "windows", "installation"],
		},
		{
			id: "image_40",
			filename: "image_40.png",
			alt: "Residential glass installation project",
			category: "commercial",
			description: "",
			tags: ["commercial", "windows", "installation"],
		},
		{
			id: "image_41",
			filename: "image_41.png",
			alt: "Residential glass installation project",
			category: "residential",
			description: "",
			tags: ["residential", "windows", "installation"],
		},
		{
			id: "image_43",
			filename: "image_43.png",
			alt: "Residential glass installation project",
			category: "residential",
			description: "",
			tags: ["residential", "windows", "installation"],
		},
		{
			id: "image_47",
			filename: "image_47.png",
			alt: "Residential glass installation project",
			category: "commercial",
			description: "",
			tags: ["commercial", "windows", "installation"],
		},
		{
			id: "image_48",
			filename: "image_48.png",
			alt: "Residential glass installation project",
			category: "residential",
			description: "",
			tags: ["residential", "windows", "installation"],
		},
		{
			id: "image_49",
			filename: "image_49.jpeg",
			alt: "Residential glass installation project",
			category: "residential",
			description: "",
			tags: ["residential", "windows", "installation"],
		},
		{
			id: "image_6",
			filename: "image_6.png",
			alt: "Residential glass installation project",
			category: "residential",
			description: "",
			tags: ["residential", "windows", "installation"],
		},
		{
			id: "image_7",
			filename: "image_7.png",
			alt: "Residential glass installation project",
			category: "residential",
			description: "",
			tags: ["residential", "windows", "installation"],
		},
		{
			id: "image_8",
			filename: "image_8.png",
			alt: "Residential glass installation project",
			category: "residential",
			description: "",
			tags: ["residential", "windows", "installation"],
		},
		{
			id: "image_9",
			filename: "image_9.png",
			alt: "Residential glass installation project",
			category: "residential",
			description: "",
			tags: ["residential", "windows", "installation"],
		},
	],
	commercial: [
		{
			id: "image_33",
			filename: "image_33.png",
			alt: "Commercial glass installation project",
			category: "commercial",
			description: "",
			tags: ["commercial", "storefront", "business"],
		},
		{
			id: "image_34",
			filename: "image_34.png",
			alt: "Commercial glass installation project",
			category: "commercial",
			description: "",
			tags: ["commercial", "storefront", "business"],
		},
		{
			id: "image_39",
			filename: "image_39.png",
			alt: "Commercial glass installation project",
			category: "commercial",
			description: "",
			tags: ["commercial", "storefront", "business"],
		},
		{
			id: "image_42",
			filename: "image_42.png",
			alt: "Commercial glass installation project",
			category: "commercial",
			description: "",
			tags: ["commercial", "storefront", "business"],
		},
		{
			id: "image_44",
			filename: "image_44.png",
			alt: "Commercial glass installation project",
			category: "commercial",
			description: "",
			tags: ["commercial", "storefront", "business"],
		},
		{
			id: "image_45",
			filename: "image_45.png",
			alt: "Commercial glass installation project",
			category: "commercial",
			description: "",
			tags: ["commercial", "storefront", "business"],
		},
		{
			id: "image_46",
			filename: "image_46.png",
			alt: "Commercial glass installation project",
			category: "commercial",
			description: "",
			tags: ["commercial", "storefront", "business"],
		},
	],
};

// Helper functions for image operations
const ALL_IMAGES = [...imageMetadata.residential, ...imageMetadata.commercial];

export const getAllImages = () => ALL_IMAGES;

/**
 * Category-aware filter that uses each item's `category` field.
 * Now you can change an item's `category` and it will render in that tab,
 * regardless of which array it was authored in.
 */
export const getImagesByCategory = (category = "all") => {
	if (category === "all") return ALL_IMAGES;
	return ALL_IMAGES.filter((img) => img.category === category);
};

export const getImagePath = (filename) =>
	`/src/assets/images/customer_photos/${filename}`;

// Search keeps working; it already uses getImagesByCategory internally.
export const searchImages = (query, category = "all") => {
	const images = getImagesByCategory(category);
	const lowerQuery = query.toLowerCase();

	return images.filter(
		(image) =>
			image.alt.toLowerCase().includes(lowerQuery) ||
			image.description.toLowerCase().includes(lowerQuery) ||
			image.tags.some((tag) => tag.toLowerCase().includes(lowerQuery)),
	);
};
